import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

function FeaturesCards() {
  const [ref1, inView1] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const [ref2, inView2] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const [ref3, inView3] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div className="min-h-screen flex flex-col justify-start items-center text-center">
      <div className="flex flex-col justify-start items-center w-[90%] max-md:w-full my-8 min-h-screen space-y-2">
        <div
          ref={ref1}
          className="flex flex-row max-md:flex-col justify-start items-center w-[90%] space-x-8 max-lg:space-x-2 max-sm:space-x-1 min-h-[350px]"
        >
          {inView1 && (
            <React.Fragment>
              <motion.img
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'slide', stiffness: 120, delay: 0.5 }}
                alt="woody"
                src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723730201/pixa-pie/features/woody.webp"
                className="object-contain md:w-[40%] w-[80%]"
              />
              <motion.span
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'slide', stiffness: 120, delay: 0.5 }}
                className={`text-white font-semibold text-[48px] leading-[64px] max-lg:text-[24px] max-lg:leading-[36px] max-md:text-[16px] max-md:leading-[30px] text-left max-md:text-center max-md:w-[80%] max-md:mt-[-48px]`}
              >
                Playtime, story time,{' '}
                <span className="max-xl:hidden">
                  <br />
                </span>
                anytime - your{' '}
                <span className={`golden-woody-main`}>new best friend</span> is
                always ready for adventure
              </motion.span>
            </React.Fragment>
          )}
        </div>
        <div
          ref={ref2}
          className="flex flex-row-reverse max-md:flex-col justify-start items-center w-[90%] max-sm:w-[90%] max-lg:w-[90%] max-lg:space-x-2 space-x-8 max-sm:space-x-0 min-h-[350px]"
        >
          {inView2 && (
            <React.Fragment>
              <motion.img
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'slide', stiffness: 120, delay: 0.5 }}
                alt="moana"
                src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723730204/pixa-pie/features/moana.webp"
                className="object-contain md:w-[40%] w-[80%]"
              />
              <motion.span
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'slide', stiffness: 120, delay: 0.5 }}
                className={`text-white font-semibold text-[48px] leading-[64px] max-md:text-[16px] max-md:leading-[30px] max-lg:text-[24px] max-lg:leading-[36px] text-right max-md:text-center max-sm:w-[80%] max-md:mt-[-48px]`}
              >
                Not just smart, but a true friend who{' '}
                <span className={`golden-moana-main my-1`}>
                  listens, learns, and grows
                </span>{' '}
                with you
              </motion.span>
            </React.Fragment>
          )}
        </div>
        <div
          ref={ref3}
          className="flex flex-row max-md:flex-col justify-start items-center w-[90%] max-sm:w-[95%] max-lg:w-[90%] max-lg:space-x-2 space-x-8 max-sm:space-x-0 min-h-[350px]"
        >
          {inView3 && (
            <React.Fragment>
              <motion.img
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'slide', stiffness: 120, delay: 0.5 }}
                alt="rocket"
                src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723730206/pixa-pie/features/rocket.webp"
                className="object-contain md:w-[40%] w-[80%]"
              />
              <motion.span
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ type: 'slide', stiffness: 120, delay: 0.5 }}
                className={`text-white font-semibold text-[48px] leading-[64px] max-md:text-[16px] max-md:leading-[30px] max-lg:text-[24px] max-lg:leading-[36px] text-left max-md:text-center max-md:w-[80%] max-md:mt-[-48px]`}
              >
                Imagine the stories you'll tell, the quests you'll conquer, the{' '}
                <span className={`golden-rocket-main`}>
                  memories you'll make together
                </span>
              </motion.span>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

export default FeaturesCards;
